import React from 'react'
import PropTypes from 'prop-types'
import {
    Typography,
    TextField,
} from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'
import StepPageLayout from 'shared/StepPageLayout'
import styles, {
    textFieldHelperTextStyle,
    textFieldStyle,
} from './TextStepField.style'

const propTypes = {
    step: PropTypes.shape({
        stepTitle: PropTypes.string.isRequired,
        helpText: PropTypes.string,
        isRequired: PropTypes.bool.isRequired,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    error: PropTypes.bool,
    helpText: PropTypes.string,
    isNested: PropTypes.bool,
    isSummaryView: PropTypes.bool,
}

const TextStepField = ({
    step,
    onChange,
    value,
    error = false,
    helpText = null,
    isNested = false,
    isSummaryView = false,
}) => {
    const { t } = useTranslation()
    const classes = useStyle(styles)
    const helperTextStyles = useStyle(textFieldHelperTextStyle)
    const textFieldStyles = useStyle(textFieldStyle)

    const defaultHelpText = step.helpText ? t(`${step.helpText}`) : ''

    return (
        <StepPageLayout
            title={t(`processDefinition:${step.stepTitle}`)}
            isRequired={step.isRequired}
            isAnswered={!!value}
            isNested={isNested}
            isSummaryView={isSummaryView}
        >
            <div css={classes.form}>
                {!isSummaryView && (
                    <TextField
                        id="outlined-helperText"
                        value={value}
                        error={Boolean(error)}
                        fullWidth
                        multiline
                        size="small"
                        helperText={helpText || defaultHelpText}
                        slotProps={{ formHelperText: { sx: helperTextStyles } }}
                        sx={textFieldStyles}
                        variant="outlined"
                        onChange={onChange}
                        disabled={isSummaryView}
                    />
                )}
                {isSummaryView && (
                    <Typography
                        variant="h5"
                        css={classes.summaryText}
                        paragraph={!value}
                    >
                        {value}
                    </Typography>
                )}
            </div>
        </StepPageLayout>
    )
}

TextStepField.propTypes = propTypes

export default TextStepField
